import { FC } from "react"
import { InfoIcon } from "@eventbrite/marmalade"
import { Typography } from "@eventbrite/marmalade"

// styles
import * as styles from "./ActionComplex.module.scss"
import { MicroCopy } from "../ContactForm/ContactForm"

export type LiveSupportChannelMicrocopy = {
  chatTitle?: MicroCopy
  selectionContactOptionsHeader?: MicroCopy
  selectionContactOptionsChatRecommendation?: MicroCopy
  selectionContactChatHeader?: MicroCopy
  selectionDescriptionChatAvailableAlways?: MicroCopy
  selectionDescriptionChatWaitTimeStatic?: MicroCopy
  selectionContactCallbackHeader?: MicroCopy
  selectionDescriptionCallbackWaitTimeStatic?: MicroCopy
  selectionDescriptionAvailabilityWeekdayBusinessHours?: MicroCopy
  selectionContactScheduleSessionHeader?: MicroCopy
  selectionDescriptionContulstationSession?: MicroCopy
  selectionDescriptionOnboardingSession?: MicroCopy
  selectionContactEmailHeader?: MicroCopy
  selectionEmailContactDescription?: MicroCopy
  selectionDescriptionAvailability247?: MicroCopy
}

export type LiveSupportUnavailableMicrocopy = {
  headerSupportTemporarilyUnavailable?: MicroCopy
  messageSupportTemporarilyUnavailable?: MicroCopy
  selectionChatUnavailableHeader?: MicroCopy
  selectionDescriptionChatUnavailable?: MicroCopy
  selectionCallbackUnavailableHeader?: MicroCopy
  selectionDescriptionCallbackUnavailable?: MicroCopy
}

export type ActionComplexProSubMicrocopy = {
  selectionContactOptionsHeader: MicroCopy
  selectionContactOptionsSubheaderPricingPackaging2dot1Chat: MicroCopy
  selectionContactOptionsSubheaderPricingPackaging2dot1ChatCta: MicroCopy
}

export type ActionComplexFlexMicrocopy = {
  selectionContactOptionsHeader: MicroCopy
  selectionContactOptionsSubheaderPricingPackaging2dot1Email: MicroCopy
}

export type ActionComplexMicrocopy = {
  actionComplexHeader: string
  actionComplexSubHeader: string
  actionComplexCta?: string
}

type Props = {
  microCopy?: ActionComplexMicrocopy
  children: any
}

const ActionComplex: FC<Props> = ({ children, microCopy }) => {
  const hasSubheader = Boolean(microCopy?.actionComplexSubHeader)

  return (
    <div
      className={`${styles?.actionContainer} ${
        hasSubheader ? styles?.hasSubheader : styles?.noSubheader
      }`}
    >
      <div className={styles?.contentContainer}>
        <div className={styles?.header}>
          <Typography variant="heading-sm" as="h3" color="neutral-1000">
            {microCopy?.actionComplexHeader}
          </Typography>
        </div>

        <div className={styles?.actionSubheaderContainer}>
          {microCopy?.actionComplexSubHeader ? (
            <>
              <InfoIcon size="small" />
              <Typography variant="body-md" as="p" color="neutral-700">
                {microCopy?.actionComplexSubHeader}
              </Typography>
            </>
          ) : null}
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default ActionComplex
